import { Box } from '@chakra-ui/react';
import Cookies from 'universal-cookie';

import styles from './styles.module.css';
import { TextBold } from 'UiKit/typography';

const Version = () => {
  const cookie = new Cookies();
  const appVersionCookie = cookie.get('appVersion');

  return (
    <Box className={styles['version__container']}>
      <TextBold className={styles['version__text']}>Version: {appVersionCookie}</TextBold>
    </Box>
  );
};

export default Version;
